import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mantine/core";
import map from "lodash/map";
import Link from "next/link";
import { useMemo } from "react";

import { ResultDetail } from "./result-detail";
import { ResultsSection } from "./results-section";
import { useTrackAnalytics } from "@/hooks/analytics.hooks";
import { MessageSenders, type Screening } from "@/types/screeners";

interface KeyAnswersProps {
  screening: Screening;
}

export const KeyAnswers = ({
  screening: { sessionId, showInSummary, voiceQuestions },
}: KeyAnswersProps) => {
  const track = useTrackAnalytics({ session_id: sessionId });
  const voiceResponse = useMemo(() => {
    const message = voiceQuestions.find(
      ({ sender }) => sender === MessageSenders.Candidate,
    )?.message;

    if (message !== "Skip") {
      return message;
    }
  }, [voiceQuestions]);

  // < 2 because voiceQuestions includes both the question and the answer
  if (
    (!showInSummary || Object.keys(showInSummary).length === 0) &&
    voiceQuestions.length < 2
  ) {
    return null;
  }

  return (
    <ResultsSection title="Key answers">
      {map(showInSummary ?? {}, (value, key) => (
        <ResultDetail key={key} label={key} value={String(value)} />
      ))}
      {voiceResponse && (
        <Button
          className="max-w-fit px-0"
          component={Link}
          href={voiceResponse}
          onClick={() => track("Voice response played")}
          rel="noopener noreferrer"
          rightSection={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
          size="xs"
          target="_blank"
          variant="transparent"
        >
          PLAY VOICE ANSWER
        </Button>
      )}
    </ResultsSection>
  );
};
